import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../theme';
import Button from '../Button';

import Dialog from './Dialog';
import { StyledDialogContent } from './Dialog.styles';

export const StyledDismissButton = styled(Button)``;

export const StyledInfoDialog = styled(Dialog)(({ theme }) => {
  return css`
    /* When a header is not rendered(e.g. progress state) the button must positioned atop. */
    ${StyledDialogContent} > ${StyledDismissButton} {
      position: relative;
      z-index: calc(${theme.base['z-index'].backdrop} + 1);
      align-self: end;
    }
  `;
});

StyledInfoDialog.defaultProps = defaultThemeProp;
